<template>
    <div>
      <vue-tribute :options="tributeOptions" :style="{width: this.width ? `${this.width}px` : 'auto'}" @tribute-replaced="handleTributeReplaced">
        <input class="tribute-demo-input" type="text" v-model="currentValue"/>
      </vue-tribute>
    </div>
</template>
<script>
import 'tributejs/scss/tribute.scss'
import VueTribute from 'vue-tribute'

export default {
  name: 'tribute-mention',
  props: {
    value: [String, Number, Object],
    sources: Array,
    triggers: {
      type: Array,
      default: function () {
        return ['@s', '@m', '@e']
      }
    },
    width: Number
  },
  data () {
    return {
      currentValue: null,
      valueType: 'string',
      targets: [],
      tributeOptions: {
        trigger: '@',
        selectClass: 'highlight',
        selectTemplate: this.handleSelectTemplate,
        menuItemTemplate: this.handleMenuItemTemplate,
        menuContainer: document.body,
        lookup: 'key',
        fillAttr: 'value',
        values: this.filterValues,
        requireLeadingSpace: false,
        allowSpaces: false,
        positionMenu: true,
        spaceSelectsMatch: true
      }
    }
  },
  watch: {
    value: {
      deep: true,
      handler (val, oldValue) {
        this.setCurrentValue(val, oldValue)
      }
    },
    currentValue (val, oldValue) {
      this.updateContent(val)
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.valueType = typeof this.value
      if (this.valueType === 'object') this.currentValue = this.value.value
      else this.currentValue = this.value
    },
    filterValues (text, cb) {
      if (!text) {
        let res = []
        cb(res)
        return
      }
      if (!this.triggers) {
        cb(this.sources)
        return
      }
      let trigger = this.triggers.find((v, i, arr) => `@${text}`.indexOf(v) > -1)
      if (trigger) {
        cb(this.sources.filter((v, i, arr) => v.value.startsWith(text)))
      }
    },
    handleSelectTemplate (item) {
      return `@${item.original.value}`
    },
    handleMenuItemTemplate (item) {
      return `${item.string} <span>${item.original.dataType === 2 ? '数值' : '文本'}</span></span>`
    },
    handleTributeReplaced (value) {
      this.currentValue = value.target.value
    },
    updateContent (textContext) {
      if (this.valueType === 'number') {
        this.$emit('update:value', textContext)
        this.$emit('updateTargets', {})
        return
      }
      if (!textContext) {
        if (this.valueType === 'object') this.$emit('update:value', {value: textContext, targets: {}})
        else this.$emit('update:value', textContext)
        this.$emit('updateTargets', {key: textContext, value: {}})
        return
      }
      let triggersStr = this.triggersToStr()
      let regex = new RegExp(`(?<=@)(${triggersStr}).[a-zA-Z\\d_.]{3,}(?=\\s)`, 'g')
      let arr = textContext.match(regex)
      this.targets = arr ? this.sources.filter(s => arr.find(o => o === s.value)) : []
      if (this.valueType === 'object') this.$emit('update:value', {value: textContext, targets: this.targets})
      else this.$emit('update:value', textContext)
      this.$emit('updateTargets', {key: textContext, value: this.targets})
    },
    triggersToStr () {
      let str = ''
      this.triggers.forEach((item, i) => {
        str += `|${item.substring(1)}`
      })
      return str.substring(1)
    },
    setCurrentValue (val, oldValue) {
      if (this.valueType === 'object') this.currentValue = val.value
      else this.currentValue = val
    }
  },
  components: {
    VueTribute
  }
}
</script>

<style lang="stylus">
    .tribute-demo-input {
      outline: none;
      border: 1px solid #eee;
      padding: 3px 5px;
      border-radius: 2px;
      font-size: 15px;
      min-height: 32px;
      cursor: text;
      width: 100%
    }
    .tribute-demo-input:focus {
      border-color: #d1d1d1;
      background-color: #fbfbfb;
    }
</style>



// WEBPACK FOOTER //
// src/components/mention/tributeMention.vue